import React, { Fragment } from 'react';
import ColorScale from '_class/ColorScale';
import { capitalize } from 'helpers/content';
import { useTranslate } from 'lib/translate';
import { Expandable, Icon } from '@haldor/ui';
import { Collapsible, ColorLabel, ColorLabelContainer } from 'UI';
import DOMPurify from 'dompurify';
import moment from 'moment';

var DisplayResource = function DisplayResource(props) {
  var translate = useTranslate();
  var resource = props.resource,
      block = props.block;
  var assessment = block.api.getEditor().getProp('assessment');
  /**
   * @param {object} row
   */

  var getRowData = function getRowData(row) {
    if (row.referenceType == 'matrixRow') {
      var _resource$value, _resource$value$detai;

      var foundRow = null;
      var addNotAchieved = true;
      (_resource$value = resource.value) === null || _resource$value === void 0 ? void 0 : (_resource$value$detai = _resource$value.details) === null || _resource$value$detai === void 0 ? void 0 : _resource$value$detai.forEach(function (_detail) {
        var _detail$matrix, _detail$matrix$_Parag;

        _detail === null || _detail === void 0 ? void 0 : (_detail$matrix = _detail.matrix) === null || _detail$matrix === void 0 ? void 0 : (_detail$matrix$_Parag = _detail$matrix._ParagraphSet) === null || _detail$matrix$_Parag === void 0 ? void 0 : _detail$matrix$_Parag.forEach(function (_paragraph) {
          var matchingRow = _paragraph.rows.find(function (_row) {
            return _row.id == row.referenceId;
          });

          if (matchingRow != null) {
            if (_detail.matrix.disableNotAchieved) {
              addNotAchieved = false;
            }

            foundRow = JSON.parse(JSON.stringify(matchingRow));
          }
        });
      });

      if (foundRow != null && addNotAchieved) {
        var _foundRow;

        if (((_foundRow = foundRow) === null || _foundRow === void 0 ? void 0 : _foundRow.cells.find(function (cell) {
          return cell.id == 'F';
        })) == null) {
          var _foundRow2;

          (_foundRow2 = foundRow) === null || _foundRow2 === void 0 ? void 0 : _foundRow2.cells.unshift({
            text: translate('Not achieved'),
            id: 'F'
          });
        }
      }

      return foundRow;
    }

    if (row.referenceType == 'assessmentGoalRow') {
      var _resource$value2;

      var _foundRow3 = (_resource$value2 = resource.value) === null || _resource$value2 === void 0 ? void 0 : _resource$value2.rows.find(function (_row) {
        return _row.id == row.referenceId;
      });

      if (_foundRow3 != null) {
        var _foundRow3$cells;

        _foundRow3.cells = (_foundRow3$cells = _foundRow3.cells) === null || _foundRow3$cells === void 0 ? void 0 : _foundRow3$cells.sort(function (a, b) {
          return a.index - b.index;
        });
      }

      return _foundRow3;
    }
  };
  /**
   * @param {object} row
   */


  var getRowParagraph = function getRowParagraph(row) {
    if (row.referenceType == 'matrixRow') {
      var _resource$value3, _resource$value3$deta;

      var foundParagraph = null;
      (_resource$value3 = resource.value) === null || _resource$value3 === void 0 ? void 0 : (_resource$value3$deta = _resource$value3.details) === null || _resource$value3$deta === void 0 ? void 0 : _resource$value3$deta.forEach(function (_detail) {
        var _detail$matrix2, _detail$matrix2$_Para;

        _detail === null || _detail === void 0 ? void 0 : (_detail$matrix2 = _detail.matrix) === null || _detail$matrix2 === void 0 ? void 0 : (_detail$matrix2$_Para = _detail$matrix2._ParagraphSet) === null || _detail$matrix2$_Para === void 0 ? void 0 : _detail$matrix2$_Para.forEach(function (_paragraph) {
          var matchingRow = _paragraph.rows.find(function (_row) {
            return _row.id == row.referenceId;
          });

          if (matchingRow != null) {
            foundParagraph = _paragraph;
          }
        });
      });
      return foundParagraph;
    }

    return null;
  };
  /**
   * @param {object} row
   */


  var getRowClarifications = function getRowClarifications(row) {
    if (props.clarifications == null) {
      return [];
    }

    var found = props.clarifications.find(function (clarification) {
      if (clarification.value == null) {
        return false;
      }

      return clarification.value.title == row.id;
    });

    if (found == null) {
      return [];
    }

    return found.value.rows;
  };

  var getCourseDetail = function getCourseDetail() {
    if (resource.value == null || resource.value.details == null) {
      return null;
    }

    return resource.value.details.find(function (detail) {
      return detail.matrixID == resource.referenceId;
    });
  };

  var renderExpiredText = function renderExpiredText() {
    var courseDetail = getCourseDetail();

    if (courseDetail != null && courseDetail.endDate != null && moment(courseDetail.endDate).isBefore(moment())) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        style: {
          marginRight: '0.5rem',
          marginLeft: '0.5rem'
        },
        name: "Alert_Red"
      }), translate('Expired'));
    }

    return null;
  };
  /**
   * @param {object} resource
   */


  var getResourceTitle = function getResourceTitle(resource) {
    var translate = block.api.getEditor().getProp('translate');
    var isStudent = block.api.getEditor().getProp('isStudent');
    var text = '';

    if (resource.referenceType == 'assessmentGoal') {
      text = translate('Goal');
    }

    if (resource.referenceType == 'matrix') {
      text = resource.value.year != null ? "".concat(resource.value.title, " ").concat(resource.value.year) : resource.value.title;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "df aic jcb"
    }, resource.referenceType !== 'assessmentGoal' ? /*#__PURE__*/React.createElement("div", {
      className: "df aic",
      style: {
        flex: 1
      }
    }, text, " ", renderExpiredText()) : /*#__PURE__*/React.createElement("div", {
      className: "assessmentGoal-dotContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "df aic",
      style: {
        flex: 1
      }
    }, text, " ", renderExpiredText()), props.course.length > 0 ? props.course.map(function (course) {
      var title = course.value.year != null ? "".concat(course.value.title, " ").concat(course.value.year) : course.value.title;
      return /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        key: course.value.id,
        tooltip: title,
        color: course.value.colorCode
      }));
    }) : null), !isStudent ? /*#__PURE__*/React.createElement("div", {
      className: "permissions"
    }, renderPermission('STUDENT', resource.permissions), renderPermission('GUARDIAN', resource.permissions)) : null);
  };
  /**
   * @param {object} resource
   */


  var getResourceColor = function getResourceColor(resource) {
    if (resource.referenceType == 'assessmentGoal') {
      return '#0f78da';
    }

    if (resource.referenceType == 'matrix') {
      return resource.value.colorCode;
    }

    return '#ccc';
  };
  /**
   * @param {object} rowData
   */


  var getColors = function getColors(rowData) {
    var showRed = false;

    if (resource.referenceType == 'assessmentGoal') {
      showRed = rowData.cells.find(function (cell) {
        return cell.type == 'NotAchievedTextField';
      }) != null;
    }

    if (resource.referenceType == 'matrix') {
      var detail = resource.value.details.find(function (detail) {
        return detail.matrix._ParagraphSet.find(function (paragraph) {
          return paragraph.rows.find(function (row) {
            return row.id == rowData.id;
          });
        });
      });

      if (detail != null && !detail.matrix.disableNotAchieved) {
        showRed = true;
      }
    }

    return new ColorScale(rowData.cells.length).get(showRed);
  };
  /**
   * @param {object} cell
   * @param {object} assessmentBlockPartRow
   */


  var getIsCellSelected = function getIsCellSelected(cell, assessmentBlockPartRow) {
    var _assessment$assessmen;

    if (assessment == null) {
      return false;
    }

    var foundInValue = (_assessment$assessmen = assessment.assessmentDetails) === null || _assessment$assessmen === void 0 ? void 0 : _assessment$assessmen.find(function (detail) {
      return detail.cellId == cell.id && detail.assessmentBlockPartRowId == assessmentBlockPartRow.id;
    });
    return foundInValue != null;
  };

  var getMatrix = function getMatrix() {
    var _resource$value4, _resource$value4$deta, _resource$value4$deta2;

    return (_resource$value4 = resource.value) === null || _resource$value4 === void 0 ? void 0 : (_resource$value4$deta = _resource$value4.details) === null || _resource$value4$deta === void 0 ? void 0 : (_resource$value4$deta2 = _resource$value4$deta.find(function (detail) {
      return detail.matrixID == resource.referenceId;
    })) === null || _resource$value4$deta2 === void 0 ? void 0 : _resource$value4$deta2.matrix;
  };
  /**
   * @param {string} target
   * @param {array} permissions
   */


  var renderPermission = function renderPermission(target, permissions) {
    var active = permissions.find(function (perm) {
      return perm.target == target && perm.referenceType == 'ASSESSMENTBLOCKPART';
    }) != null;
    return /*#__PURE__*/React.createElement("div", {
      className: "permission"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: active ? "Eye" : "Eye_Off"
    }), translate(capitalize(target)));
  };

  var renderMatrixOrGoal = function renderMatrixOrGoal(row, paragraph, assessmentBlockPartRow, clarifications, colors) {
    var isStudent = block.api.getEditor().getProp('isStudent');
    var rowText = row.description != null ? row.description : row.text;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: row.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "df row"
    }, paragraph != null ? /*#__PURE__*/React.createElement("div", null, paragraph.paragraphNr, ".", row.sentenceNr) : null, rowText != null ? /*#__PURE__*/React.createElement("div", {
      className: "column-text",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize(rowText.replace(new RegExp("\r\n", "g"), "<br />"))
      }
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "cells df"
    }, row.cells.map(function (cell, index) {
      var selected = getIsCellSelected(cell, assessmentBlockPartRow);
      return /*#__PURE__*/React.createElement("div", {
        className: selected ? 'cell selected' : 'cell',
        style: {
          '--level-color': colors[index]
        },
        key: cell.id
      }, cell.value != null ? cell.value : cell.text, /*#__PURE__*/React.createElement(Icon, {
        name: "Check"
      }));
    }))), clarifications.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "clarifications display-resource"
    }, /*#__PURE__*/React.createElement(Collapsible, {
      trigger: translate('Clarifications')
    }, clarifications.map(function (clarification) {
      return /*#__PURE__*/React.createElement("div", {
        className: "df row",
        key: clarification.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "column-text"
      }, clarification.description), /*#__PURE__*/React.createElement("div", {
        className: "cells df"
      }, clarification.cells.map(function (cell) {
        return /*#__PURE__*/React.createElement("div", {
          className: "cell",
          key: cell.id
        }, cell.value);
      })));
    }), !isStudent ? /*#__PURE__*/React.createElement("div", {
      className: "color--meta"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Alert",
      bw: true
    }), " ", translate('Existing clarifications will not be copied and cannot be edited. Move them to an assessment goal instead.')) : null)) : null);
  };

  var assessmentBlockPartRows = resource.assessmentBlockPartRows;
  var feedbacks = [];

  if (assessment != null) {
    var _assessment$assessmen2;

    feedbacks = (_assessment$assessmen2 = assessment.assessmentFeedbacks) === null || _assessment$assessmen2 === void 0 ? void 0 : _assessment$assessmen2.filter(function (feedback) {
      return feedback.assessmentBlockPartId == resource.id;
    });
  }

  if ((resource.assessmentBlockPartRows == null || resource.assessmentBlockPartRows.length == 0) && feedbacks.length == 0) {
    return null;
  }

  var matrix;

  if (resource.referenceType == 'matrix') {
    matrix = getMatrix();

    if (matrix == null || matrix._ParagraphSet == null) {
      return null;
    }
  }

  return /*#__PURE__*/React.createElement(Expandable, {
    title: getResourceTitle(resource),
    color: getResourceColor(resource),
    open: true,
    ignorePropsUpdate: true
  }, resource.referenceType == 'matrix' && matrix._ParagraphSet.map(function (paragraph) {
    var paragraphUsed = paragraph.rows.map(function (row) {
      return assessmentBlockPartRows.find(function (selectedRow) {
        return selectedRow.referenceId == row.id;
      });
    });

    if (paragraphUsed != null && paragraphUsed[0] != null) {
      return /*#__PURE__*/React.createElement("div", null, paragraph.title != null ? /*#__PURE__*/React.createElement("div", {
        className: "matrix-paragraph-title"
      }, paragraph.title) : null, paragraph.subtitle != null ? /*#__PURE__*/React.createElement("div", {
        className: "matrix-paragraph-subtitle"
      }, paragraph.subtitle) : null, paragraph.rows.map(function (row) {
        var assessmentBlockPartRow = assessmentBlockPartRows.find(function (selectedRow) {
          return selectedRow.referenceId == row.id;
        });

        if (assessmentBlockPartRow != null) {
          row = getRowData(assessmentBlockPartRow);
          paragraph = getRowParagraph(assessmentBlockPartRow);

          if (row == null) {
            return null;
          }

          var clarifications = getRowClarifications(row);
          var colors = getColors(row);
          return renderMatrixOrGoal(row, paragraph, assessmentBlockPartRow, clarifications, colors);
        }
      }));
    }
  }), resource.referenceType == 'assessmentGoal' && assessmentBlockPartRows.map(function (assessmentBlockPartRow) {
    var row = getRowData(assessmentBlockPartRow);
    var paragraph = getRowParagraph(assessmentBlockPartRow);

    if (row == null) {
      return null;
    }

    var clarifications = getRowClarifications(row);
    var colors = getColors(row);
    return renderMatrixOrGoal(row, paragraph, assessmentBlockPartRow, clarifications, colors);
  }), feedbacks != null && feedbacks.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "feedbacks"
  }, feedbacks.map(function (feedback) {
    return /*#__PURE__*/React.createElement(Collapsible, {
      key: feedback.id,
      trigger: translate('Feedback'),
      defaultOpen: true
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.text
      }
    }));
  })) : null);
};

export default DisplayResource;